import React from 'react';
import { StyleSheet, Text, View, TextInput, Button, Image, TouchableOpacity } from 'react-native';
import {
    useFonts,
    Roboto_100Thin,
    Roboto_100Thin_Italic,
    Roboto_300Light,
    Roboto_300Light_Italic,
    Roboto_400Regular,
    Roboto_400Regular_Italic,
    Roboto_500Medium,
    Roboto_500Medium_Italic,
    Roboto_700Bold,
    Roboto_700Bold_Italic,
    Roboto_900Black,
    Roboto_900Black_Italic,
} from '@expo-google-fonts/roboto';
import { Linking } from 'react-native';
import { changeCity } from './actions/change_city'
import { weather } from './actions/weather_data';  // Changing weather action Redux
import { clearWeather } from './actions/clear_weather';  // Changing weather action Redux
import { useSelector, useDispatch } from 'react-redux';
import search_icon from '../assets/search_icon.png';
export default function WeatherDetails() {
    let [fontsLoaded] = useFonts({
        Roboto_100Thin,
        Roboto_100Thin_Italic,
        Roboto_300Light,
        Roboto_300Light_Italic,
        Roboto_400Regular,
        Roboto_400Regular_Italic,
        Roboto_500Medium,
        Roboto_500Medium_Italic,
        Roboto_700Bold,
        Roboto_700Bold_Italic,
        Roboto_900Black,
        Roboto_900Black_Italic,
    });
    const dispatch = useDispatch();
    const REACT_APP_API_URL = 'https://api.openweathermap.org/data/2.5';
    const REACT_APP_API_KEY = '5d361ddf57410aae46781a0990a8d7f6';
    const REACT_APP_ICON_URL = 'https://openweathermap.org/img/w';
    const [state, setState] = React.useState({});
    const [tdata, settData] = React.useState([]);
    // We are getting data from Redux in this file
    var data = useSelector(state => state.weather);

    const fetchWeatherByCity = async (city) => {
        await fetch(`${REACT_APP_API_URL}/weather/?q=${city}&units=metric&APPID=${REACT_APP_API_KEY}`)
            .then(res => res.json())
            .then(result => {

                settData(result);

                console.log(result);
                if (typeof data.main !== 'undefined') {
                    dispatch({
                        type: "CHANGE_WEATHER",
                        payload: result,
                    }); // Storing data in Redux
                }
            });
    }
    const ColoredLine = ({ color }) => (
        <hr
            style={{

                backgroundColor: color,
                height: 5,
                width: '100%'
            }}
        />
    );

    const [t, st] = React.useState('');
    return (
        <View style={styles.main_wrapper}>
            <Text style={{ color: '#fff', fontFamily: 'Roboto_700Bold', }}>Made with ❤️️ by <Text style={{ textDecorationLine: 'underline' }} onPress={() => window.open('https://www.facebook.com/arefin.anwar.71/', "_blank")}>Arefin Anwar</Text></Text>
            <Text style={{ color: '#fff', fontFamily: 'Roboto_400Regular', }}>Email: <Text style={{ textDecorationLine: 'underline' }} onPress={() => window.open('mailto:arefinanwar112@gmail.com', "_blank")}>arefinanwar112@gmail.com</Text></Text>
            <Text>  </Text>
            <View style={{ flexDirection: 'row', width: '110%' }}>
                <TextInput onChangeText={(value) => st(value)} style={styles.search_bar} placeholder="Another Location" placeholderTextColor="#fff"></TextInput>
                <TouchableOpacity onPress={() => fetchWeatherByCity(t)}><Image source={search_icon} style={{ width: 30, height: 30 }} /></TouchableOpacity>
            </View>
            <ColoredLine color="#596972" />
            <View style={{ height: 120 }}></View>
            <Text style={styles.title_weather}>Weather Details</Text>

            <View style={{ flexDirection: 'row', align_items: "center", marginTop: 50, }}>
                <Text style={styles.weather_element}>Cloudy</Text>
                <Text style={styles.weather_element_value}>{data.clouds.all}%</Text>
            </View>
            <View style={{ flexDirection: 'row', align_items: "center", marginTop: 28, }}>
                <Text style={styles.weather_element}>Humidity</Text>
                <Text style={styles.weather_element_value}>{data.main.humidity}%</Text>
            </View>
            <View style={{ flexDirection: 'row', align_items: "center", marginTop: 28, }}>
                <Text style={styles.weather_element}>Wind Speed</Text>
                <Text style={styles.weather_element_value}>{data.wind.speed} ms</Text>
            </View>
            <View style={{ flexDirection: 'row', align_items: "center", marginTop: 28, }}>
                <Text style={styles.weather_element}>Wind Degree</Text>
                <Text style={styles.weather_element_value}>{data.wind.deg}°</Text>
            </View>
            <View style={{ flexDirection: 'row', align_items: "center", marginTop: 28, }}>
                <Text style={styles.weather_element}>Weather Description</Text>
                <Text style={styles.weather_element_value}>{data.weather[0].description}</Text>

            </View>

        </View>
    )
}

const styles = StyleSheet.create({
    main_wrapper: {
        width: 330,
        height: 500,
        marginTop: 56,
        //backgroundColor: "#000",
    },
    search_bar: {
        height: 35,
        width: '80%',
        color: "#fff",
        fontFamily: 'Roboto_300Light',
        fontSize: 24,
    },
    title_weather: {
        color: "#fff",
        fontFamily: 'Roboto_400Regular',
        fontSize: 24,
    },
    weather_element: {
        color: "#D1D1D1",
        fontFamily: 'Roboto_300Light',
        fontSize: 20,
    },
    weather_element_value: {
        color: "#D1D1D1",
        fontFamily: 'Roboto_300Light',
        fontSize: 20,
        position: "absolute",
        right: 0,
    }
})
